module.exports = __webpack_public_path__ + "img/login_text.18bf81f8.png";